module.exports = __webpack_public_path__ + "static/media/bike.edc9e246.jpg";